export function mapEntriesForSelect(items) {
    return Object.entries(items).map((val) => ({'id': val[0], 'name': val[1]}));
}

export function mapValuesForSelect(items) {
    return Object.values(items).map((val) => ({'id': val.value, 'name': val.name}));
}